import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { camelToDisplay } from '@iotv/datamodel-core';
import { TabContext, TabList } from '@mui/lab';
import { Tab, Typography } from '@mui/material';
import { useTabHandler } from '../../../hooks/useTabHandler';
import { GoogleRoundTrip } from './tabs';
export const SlotIO = ({}) => {
    const tabsToDisplay = {
        RoundTrip: _jsx(GoogleRoundTrip, {}),
    };
    const { handlers: { handleTabChange }, state: [[tabIdx, setTabIdx]], } = useTabHandler(tabsToDisplay);
    const getTabName = (idx) => Object.keys(tabsToDisplay)[idx];
    const getTabIndex = (str) => Object.keys(tabsToDisplay).indexOf(str);
    return (_jsxs("div", { children: [_jsx(Typography, { variant: 'h6', children: `IO ${tabIdx}` }), _jsxs(TabContext, { value: getTabName(tabIdx), children: [_jsx(TabList, { onChange: (e, newTabName) => setTabIdx(getTabIndex(newTabName)), children: Object.keys(tabsToDisplay).map((k) => (_jsx(Tab, { label: camelToDisplay(k), value: k }, k))) }), Object.entries(tabsToDisplay).map(([k, c]) => c)] })] }));
};
